import { ScreenSize } from "models/screenSize";
import { useEffect, useState } from "react";

const useMediaQuery = (screenSize: ScreenSize) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    let query = "";
    switch (screenSize) {
      case ScreenSize.xxs:
        query = "(max-width: 480px)";
        break;
      case ScreenSize.xs:
        query = "(max-width: 575px)";
        break;
      case ScreenSize.sm:
        query = "(min-width: 576px)";
        break;
      case ScreenSize.md:
        query = "(min-width: 768px)";
        break;
      case ScreenSize.xl:
        query = "(min-width: 1200px)";
        break;
      case ScreenSize.xxl:
        query = "(min-width: 1400px)";
        break;
      default:
        query = "";
        break;
    }
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, screenSize]);

  return matches;
};

export default useMediaQuery;
